import React, { PropTypes } from 'react';
import * as Item from './services/Item';
import moment from 'moment';
import i18n from '../../../i18n';
import {PENDING_QUOTATION} from "../../../data/booking/constants/quotation_status";
import {Place} from "./services/Item";

const BagTransport = ({ service, item }) =>
    <Item.Root isActive={false} status={item.updateStatus}>
        <Item.Date date={moment(item.date)}/>
        <Item.Quantity icon="suitcase" quantity={item.bags}/>
        <Item.FromTo from={item.from} to={item.to}/>
        {item.subContractor && <Item.SubContractor />}
        {service.status != PENDING_QUOTATION && <Item.Price price={item.total}/>}
    </Item.Root>
;

const BikeTransport = ({ service, item }) =>
    <Item.Root isActive={false} status={item.updateStatus}>
        <Item.Date date={moment(item.date)}/>
        <Item.Quantity icon="bicycle" quantity={item.bikes}/>
        <Item.FromTo from={item.from} to={item.to}/>
        {item.subContractor && <Item.SubContractor />}
        {service.status != PENDING_QUOTATION && <Item.Price price={item.total}/>}
    </Item.Root>
;

const PeopleTransport = ({ service, item }) =>
    <Item.Root isActive={false} status={item.updateStatus}>
        <Item.Date date={moment(item.date)}/>
        <div>
            <Item.Quantity icon="male" quantity={item.people}/>
            <hr className="mx-auto border-1 border-solid border-stone-300 w-1/2"/>
            <Item.Departure departure={item.hour}/>
        </div>
        <Item.FromTo from={item.from} to={item.to}/>
        {item.subContractor && <Item.SubContractor/>}
        <Item.Price price={item.total}/>
    </Item.Root>
;

const RegularShuttle = ({service, item}) =>
    <Item.Root isActive={false} status={item.updateStatus}>
        <Item.Date date={moment(item.date)}/>
        <div>
            <Item.Quantity icon="male" quantity={item.people}/>
            <hr className="mx-auto border-1 border-solid border-stone-300 w-1/2"/>
            <Item.Departure departure={item.hour}/>
        </div>
        <Item.FromTo from={item.from} to={item.to}/>
        {item.subContractor && <Item.SubContractor />}
        {service.status != PENDING_QUOTATION && <Item.Price price={item.total}/>}
    </Item.Root>
;

const CarTransport = ({ service, item }) =>
    <Item.Root isActive={false} status={item.updateStatus}>
        <Item.Date date={moment(item.date)}/>
        <Item.Quantity icon="car" quantity={item.vehicleCount}/>
        <Item.FromTo from={item.collectionPlace} to={item.depositPlace} />
        {item.subContractor && <Item.SubContractor />}
        <Item.Price price={item.total}/>
    </Item.Root>
;

const CarParking = ({ service, item }) =>
    <Item.Root isActive={false} status={item.updateStatus}>
        <Item.Date date={moment(item.date)}/>
        <Item.Quantity icon="car" quantity={item.vehicleCount}/>
        <Item.Place place={item.place} />
        <Item.Price price={item.total}/>
    </Item.Root>
;

const Custom = ({ service, item }) =>
    <Item.Root isActive={false} status={item.updateStatus}>
        <Item.Date date={moment(item.date)}/>
        <Item.Quantity icon="misc" quantity={item.quantity}/>
        <Item.Designation designation={item.label} />
        <Item.Comment comment={item.comment} />
        <Item.Price price={item.total}/>
    </Item.Root>
;

const Cancellation = ({ service, item }) =>
    <Item.Root isActive={false} status={item.updateStatus}>
        <Item.Date date={moment(item.date)}/>
        <Item.Designation designation={i18n.t('followup.cancellation_service')} />
        <Item.Price price={item.total}/>
    </Item.Root>
;

const RoadbookMhikes = ({ service, item }) =>
    <Item.Root isActive={false} status={item.updateStatus}>
        <Item.Date date={moment(item.date)}/>
        <Item.Designation designation={i18n.t('followup.roadbook')} />
        <Item.Price price={item.total}/>
    </Item.Root>
;

export {
    BagTransport,
    PeopleTransport,
    RegularShuttle,
    CarTransport,
    Custom,
    Cancellation,
    RoadbookMhikes,
    BikeTransport,
    CarParking
};
